import { AgResourceLanguage } from '../types';
import { subscriptionDetails as EnUsSubscriptionDetails } from '../en-us/subscriptionDetails';

export const subscriptionDetails: AgResourceLanguage['subscriptionDetails'] = {
  ...EnUsSubscriptionDetails,
  orderFields: {
    subscriptionTextBtn: 'Lägg till Produkt i Abonnemang',
    subscriptionSubtotal: 'Delsumma för Abonnemang',
    nextSubtotal: 'Delsumma för Engångs-tillägg',
    nextTextBtn: 'Lägg till Produkt i Nästa Beställning',
    subscriptionTitle: 'Abonnemangsprodukter',
    nextTitle: 'Engångs-tillägg'
  },
  active: {
    exploreButton: 'Lägg till produkt',
    free: 'Gratis',
    shippingAddress: 'Leveransadress',
    subscriptionButton: 'Lägg till Produkter',
    orderTotal: 'Totalt för Beställning:',
    nextOrderButton: 'Lägg till Produkt i Nästa Beställning',
    emtyTitle: 'Engångs-tillägg:',
    qty: 'x',
    subscriptionProductsTitle: 'Abonnemangsprodukter',
    lastOrderDetails: 'Detaljer om Sista Beställning',
    backButton: 'Tillbaka till Listan',
    emptyText:
      'Handla hela sortimentet av AG1-produkter och tillbehör, exklusivt tillgängliga för medlemmar.',
    emptyButton: 'Lägg till Produkt i Nästa Beställning',
    nextOrderLabel: 'Nästa Beställningsdatum:',
    addOns: 'Engångs-tillägg:',
    nextShipmentTitle: 'Nästa Beställning'
  },
  reactivate: {
    headline: 'Ditt abonnemang har avbrutits och en bekräftelse kommer att skickas till {{email}}.',
    title: 'Om du saknar oss...',
    subTitle:
      'Vi skulle gärna vilja ha dig tillbaka! Visste du att dessa alternativ gör det enkelt att hoppa över en leverans eller få mer värde från ditt AG1- abonnemang?',
    agzSubTitle:
      'Vi vill gärna ha dig tillbaka! Du kan logga in och starta om din prenumeration när som helst genom att klicka på "återaktivera".',
    reactivateOfferCard: {
      delay: {
        heading: '”Jag har för mycket.”',
        text: 'Behöver du lite tid att komma ikapp? Fördröj din nästa leverans av AG1.',
        btnText: 'Återaktivera & Fördröj'
      },
      skip: {
        heading: '”Jag har för mycket.”',
        text: 'Behöver du lite tid att komma ikapp? Hoppa över din nästa leverans av AG1.',
        btnText: 'Återaktivera & Hoppa över'
      },
      switch: {
        heading: '”Jag har en stram budget.”',
        textTwoPouches:
          'Byt till 2 påsar som skickas var 60:e dag för att dra nytta av medlemspriser med färre leveranser (ett värde av 18 {{symbolCurrency}}).',
        textThreePouches:
          'Byt till 3 påsar som skickas var 90:e dag för att dra nytta av medlemspriser och fri frakt – ett värde av 42 {{symbolCurrency}}.',
        btnText: 'Återaktivera & Byt'
      },
      upgrade: {
        heading: '“Jag gillar inte smaken.”',
        text: 'Med ett klick byter du din prenumeration till vår uppgraderade formel med mer probiotika, näringsämnen och ny tropisk smak.',
        learnMoreLinkText: 'Läs mer.',
        btnText: 'Återaktivera och uppgradera'
      }
    }
  },
  reactivateConfirm: {
    ...EnUsSubscriptionDetails.reactivateConfirm,
    title: 'Bekräfta din nya plan',
    tableHead: 'Du debiteras den:',
    tableSubHead: 'Du har låst upp ett',
    tableSubHeadValue: 'värde',
    tableSubHeadOn: 'på',
    subTotal: 'Delsumma',
    shipping: 'Frakt',
    free: 'GRATIS',
    total: 'Totalt',
    confirmButton: 'Bekräfta',
    cancelButton: 'Nej tack',
    offer: {
      subtitleThreePouches:
        'Återaktivera ditt abonnemang och dra nytta av medlemspriser och gratis frakt – ett värde av {{symbolCurrency}}42.',
      subtitleTwoPouches:
        'Återaktivera ditt abonnemang och dra nytta av medlemspriser med färre leveranser – ett värde av {{symbolCurrency}}18.',
      promotionText: '{{pouches}} påsar och färre leveranser'
    },
    newPlan: {
      title: 'Din nya AG1-plan:',
      titleSecondary: 'Ditt AG1 skickas:',
      mainText: '{{pouches}} påsar som skickas var {{days}} dag',
      nextShipment: 'Nästa leverans:'
    }
  },
  reactivateSuccess: {
    ...EnUsSubscriptionDetails.reactivateSuccess,
    title: 'Vi är glada att ha dig tillbaka!',
    subBtn: 'Se mitt abonnemang',
    learnMore: {
      title: 'Grundläggande näring i en enda skopa',
      text: 'Varje skopa AG1 innehåller alla hälsofördelar du behöver för hela kroppen i en enkel daglig vana.*',
      btnText: 'Läs mer'
    },
    offer: {
      skip: 'Vi har återaktiverat ditt medlemskap och hoppat över din nästa leverans. Tillsammans tar vi hand om vår hälsa.',
      delay:
        'Vi har återaktiverat ditt medlemskap och skjutit upp din nästa leverans. Tillsammans tar vi hand om vår hälsa.',
      default: 'Vi har återaktiverat ditt medlemskap. Tillsammans tar vi hand om vår hälsa.'
    }
  },
  v2: {
    ...EnUsSubscriptionDetails.v2,
    active: {
      ...EnUsSubscriptionDetails.v2.active,
      nextOrderTitle: 'Nästa order',
      shippingFrequency: 'Leveransfrekvens',
      item: 'Varje'
    },
    editFrequency: {
      day: 'Dag'
    },
    orderItems: {
      subscriptionDescription: 'Abonnemang',
      nextOrderOnlyDescription: 'Endast för denna order',
      toBeAppliedAfterNextOrder: 'Tillämpar efter nästa order'
    },
    reactivate: {
      success: 'Ditt abonnemang har återaktiverats'
    },
    errors: {
      apiError:
        'We ondervinden een tijdelijk technisch probleem. Probeer het later opnieuw alstublieft.'
    }
  }
};
